import { inject } from '@angular/core';
import { TrustCenterFacadeService } from '@anecdotes/shared-trust-center';
import { DOCUMENT } from '@angular/common';
import { filter, firstValueFrom, map } from 'rxjs';

export async function setFavicon(): Promise<void> {
  const trustCenterFacadeService = inject(TrustCenterFacadeService);
  const document = inject(DOCUMENT);

  const faviconUrl = await firstValueFrom(trustCenterFacadeService
    .getTrustCenterInfo()
    .pipe(
      map((info) => info?.favicon_url),
      filter(Boolean),
    ),
  );

  document.getElementById('custom-favicon').setAttribute('href', faviconUrl);
}
